module.exports = __webpack_public_path__ + "static/img/torso11.ebc2d892.jpg";